import { api } from '../createApi';
import { TagType } from '../TagType';

export const TAG_BY_LIST = { type: TagType.Fields, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.Fields as TagType],
  endpoints: {
    getFields: {
      providesTags: [TAG_BY_LIST],
    },
  },
});
